import React from 'react'
import {connect} from 'react-redux'
import DesktopHeader from 'containers/Header/Desktop'
import MobileHeader from 'containers/Header/Mobile'
import Spreadsheet from 'containers/Spreadsheet'
import Sidebar from 'containers/Sidebar'
import Container from 'components/Container'
import PageNavigation from 'containers/PageNavigation'
import TableBottom from 'containers/TableBottom'
import TableMenu from 'containers/TableMenu'
import TableTop from 'containers/TableTop'
import TableSideButtons from 'containers/TableSideButtons'
import {
    fetchRenameEntity
} from 'modules/entities/actions'
import {
    initCollection,
    setCollectionView,
    selectionChange,
    handleSelectView
} from 'modules/collection/actions'
import {fieldtype} from 'utils/enums/fieldtype'
import route from 'utils/enums/route'
import {isMobile} from 'utils/utils'

class List extends React.Component {
    constructor(props) {
        super(props)

		this.mobile = isMobile()

        this.state = {
            targetCol: null,
            showHidden: false
        }
    }

    componentDidMount() {
        this.props.initCollection(Number(this.props.params.list), route.List)
    }

    componentDidUpdate(props) {
        if (this.props.params.list !== props.params.list) {
            this.props.initCollection(Number(this.props.params.list), route.List)
            this.setState({ targetCol: null })
            this.props.selectionChange([])
        }

		if (this.props.entityId !== props.entityId && this.props.selected.length) {
            this.props.selectionChange([])
        }

        if (this.props.initError) {
            this.props.navigate('/')
        }
    }

    handleSelectCol = (targetCol) => {
        this.setState({ targetCol })
    }

    handleCloseMenu = () => {
        this.setState({ targetCol: null })
    }

    onRowClick = (record) => {
        this.props.navigate(`/${route.Record}/${this.props.entityId}/${record}/${this.props.currentViewId}`)
    }

    toggleVisibility = () => {
        this.setState(state => ({showHidden: !state.showHidden}))
    }

    handleSelectView = (id) => {
        this.props.handleSelectView(id)
        this.props.setCollectionView(id)
        this.setState({ targetCol: null })
        this.props.selectionChange([])
    }

    getOrder = (columns, order) => {
        const result = order ? [...order] : []
        columns.forEach((column) => {
            if (result.indexOf(column.name) === -1) {
                result.push(column.name)
            }
        })

        if (order) {
            order.forEach((item) => {
                if (columns.findIndex(column => column.name === item) === -1) {
                    result.splice(result.indexOf(item), 1)
                }
            })
        }

        return result
    }

    render() {
        let lockColumn, columns, order
        const {entityId, currentViewId, collectionState, entities, views} = this.props
        const view = views.find(item => item.id === currentViewId)
        const globalView = view ? view.isGlobal : false
        const table = entities.find(item => item.id === entityId)
        const fields = table && table.fields
        if (table) {
            lockColumn = fields.filter(item =>
                collectionState && (!collectionState.fieldsHidden.find(field => field === item.id) || this.state.showHidden) && collectionState.fieldLocked === item.id && item.uiType !== fieldtype.pointer).map(item => {
                const width = collectionState.fieldsWidths.find(obj =>
                    obj.id === item.id) ? collectionState.fieldsWidths.find(obj =>
                        obj.id === item.id).width : 200
                const lookupField = item.uiType === fieldtype.lookup && item.foreignerFCNs.length === 1 ?
					item.foreignerFields[0] : null
				const readonly = !!collectionState.fieldsReadonly.find(field =>
					field === item.id)

                return {
                    name: item.id,
                    title: item.singular,
                    width,
                    type: item.uiType,
                    config: item.uiConfig,
                    foreignerEcn: item.foreignerEcn,
                    linkedRelation: item.linkedRelation[0],
                    lookupConfig: lookupField && lookupField.uiConfig,
                    lookupType: lookupField && lookupField.uiType,
					readonly,
                    fixedField: true,
                    connection: !!item.connection
                }
            })

            columns = fields.filter(item => {
				const hidden = collectionState ? !!collectionState.fieldsHidden.find(field =>
                    field === item.id) : false
                return collectionState && (!hidden || this.state.showHidden) &&
                    collectionState.fieldLocked !== item.id && item.uiType !== fieldtype.pointer}).map(item => {
                    const width = collectionState.fieldsWidths.find(obj =>
                        obj.id === item.id) ? collectionState.fieldsWidths.find(obj =>
                            obj.id === item.id).width : 200
                    const lookupField = item.uiType === fieldtype.lookup && item.foreignerFCNs.length === 1 ?
                        item.foreignerFields[0] : null
					const hidden = !!collectionState.fieldsHidden.find(field =>
						field === item.id)
					const readonly = !!collectionState.fieldsReadonly.find(field =>
						field === item.id)

                    return {
                        name: item.id,
                        title: item.singular,
                        width,
                        type: item.uiType,
                        config: item.uiConfig,
                        foreignerEcn: item.foreignerEcn,
                        linkedRelation: item.linkedRelation[0],
                        lookupConfig: lookupField && lookupField.uiConfig,
                        lookupType: lookupField && lookupField.uiType,
						hidden,
						readonly,
                        connection: !!item.connection
                    }
                })

            order = collectionState ? this.getOrder(columns, collectionState.fieldsOrder) : []
        }

        const targetCol = this.state.targetCol ? fields.find(item => item.id === this.state.targetCol) : null

        return (
            <React.Fragment>
                {this.mobile ?
                    <MobileHeader
                        height='117px'
                        logo={this.props.logo}
                    >
                        {this.props.listId &&
							<PageNavigation
								id={this.props.listId}
								mobile={this.mobile}
								permissions={this.props.permissions}
                                type={route.List}
							/>
						}
                        <TableMenu
                            entityId={entityId}
                            handleSelectView={this.handleSelectView}
                            listId={this.props.listId}
                            toggleVisibility={this.toggleVisibility}
                            showHidden={this.state.showHidden}
                            filterCount={collectionState ? collectionState.filters.length : 0}
                            entityName={table && table.singular}
                            mobile={this.mobile}
                            globalView={globalView}
                        />
                    </MobileHeader>
                    :
                    <DesktopHeader padding={global.SIDE_BAR_SMALL_WIDTH}>
						{this.props.listId &&
							<PageNavigation
								id={this.props.listId}
								permissions={this.props.permissions}
                                type={route.List}
							/>
						}
                        {this.state.targetCol ?
                            <TableTop
                                globalView={globalView}
                                type={targetCol.uiType}
                                config={targetCol.uiConfig}
                                activeLock={lockColumn.length && lockColumn[0].name === this.state.targetCol}
                                hiddenField={collectionState && collectionState.fieldsHidden.find(item => item === this.state.targetCol)}
								readonlyField={collectionState && collectionState.fieldsReadonly.find(item => item === this.state.targetCol)}
                                fieldName={targetCol.singular}
                                sorting={collectionState && collectionState.sorting.find(item => item.fieldId === this.state.targetCol)}
                                handleCloseMenu={this.handleCloseMenu}
                                entitiesCount={entities.length}
                                entity={entityId}
                                targetCol={this.state.targetCol}
                                linkedTemplate={targetCol.linkedTemplate}
                                foreignerEcn={targetCol.foreignerEcn}
                                relation={targetCol.linkedRelation}
                                foreignerFcns={targetCol.foreignerFCNs}
                                connection={targetCol.connection}
                            />
                            :
                            <TableMenu
                                entityId={entityId}
                                handleSelectView={this.handleSelectView}
                                listId={this.props.listId}
                                toggleVisibility={this.toggleVisibility}
                                showHidden={this.state.showHidden}
                                filterCount={collectionState ? collectionState.filters.length : 0}
                                entityName={table && table.singular}
                                hiddenCount={collectionState ? collectionState.fieldsHidden.length : 0}
                                globalView={globalView}
                            />
                        }
                    </DesktopHeader>
                }
                {!this.mobile &&
                    <Sidebar
                        size={global.SIDE_BAR_SMALL_WIDTH}
                        logo={this.props.logo}
                    >
                        <TableSideButtons
                            name={table && table.singular}
                            list
                        />
                    </Sidebar>
                }
                <Container mobile={this.mobile} bottom  marginTop={117}>
                    {entityId && table &&
                        <Spreadsheet
                            columns={columns}
                            handleSelectCol={this.handleSelectCol}
                            order={order}
                            lockColumn={lockColumn[0]}
                            selectedRows={this.props.selected}
                            view={this.props.currentViewId}
                            mobile={this.mobile}
                            onRowClick={this.onRowClick}
                            onIconClick={this.onRowClick}
                            
                        />
                    }
                </Container>
                <TableBottom
                    mobile={this.mobile}
                    entity={entityId}
                    connection={table ? !!table.connection : false}
                />
            </React.Fragment>
        )
    }
}

const mapStateToProps = ({entities, collection, applications, login}) => ({
    entities: entities.entities,
    entityId: collection.entityId,
    initError: collection.initError,
    listId: collection.listId,
    collectionState: collection.collectionState,
    selected: collection.selected,
    logo: applications.logo,
    currentViewId: collection.currentViewId,
    views: collection.views,
	permissions: login.permissions
})

export default connect(mapStateToProps, {
    handleSelectView,
    fetchRenameEntity,
    selectionChange,
    initCollection,
    setCollectionView
})(List)
